export default {
  timeAgoJustNow: 'Just now',
};
